import { TabView, TabPanel, TabViewTabChangeEvent } from "primereact/tabview";
import { ReactElement } from "react";
import { ITabConfig } from "../../types/ITabConfig";
import { ITabProps } from "../../types/ITabProps";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { inspectionsActiveTabSelector, setActiveTab } from "../../features/inspectionsSlice";
import { actionMap, GA_BUTTON_EVENT } from "../../constants/GaEvents";
import { sendGAEvent } from "../../services/AnalyticsService";

export const Tabs = (props: ITabProps): ReactElement => {
    const dispatch = useAppDispatch();
    const activeTab = useAppSelector(inspectionsActiveTabSelector);

    const handleTabChange = (e: TabViewTabChangeEvent) => {
        dispatch(setActiveTab(e.index));

        const action: string = actionMap[e.index];

        if (action) {
            sendGAEvent(GA_BUTTON_EVENT, action);
        }
    };

    return (
        <TabView
            className=""
            activeIndex={activeTab}
            onTabChange={handleTabChange}
        >
            {props.tabs.map((tab: ITabConfig) => {
                return (
                    <TabPanel key={tab.title} header={tab.title}>
                        {tab.content}
                    </TabPanel>
                );
            })}
        </TabView>
    );
};
